import { MODAL_NAMES } from '#client/constants/modals';
import useModalContext from '#client/hooks/useModalContext';

const useCheckDepositModal = () => {
  const { openModal } = useModalContext();

  const openCheckDepositModal = ({ actionsKit = null, isResubmit = false }) => {
    openModal({
      name: MODAL_NAMES.DOWNLOAD_APP_MODAL,
      actionsKit,
      isResubmit
    });
  };

  return openCheckDepositModal;
};

export default useCheckDepositModal;
